(function() {
  'use strict';

  angular.module('app.development')
    .controller('DialogCtrl', DialogCtrl);

  function DialogCtrl($scope, $uibModalInstance, message) {
    $scope.message = message;

    $scope.ok = function() {
      $uibModalInstance.close('yes');
    };

    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.close = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }
}());
